import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import styles from "./ClearChatButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

export const ClearChatButton = ({ className, disabled, onClick }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""} ${disabled && styles.disabled}`} onClick={onClick}>
            <DeleteOutlineIcon />
            <div>{"Clear chat"}</div>
        </div>
    );
};
